import * as API from 'common/constant/routes'
import { getJson, postJson, putFile } from 'helper/http'
import toSnakeCase from '@deliverance-ai/map-keys-case/to-snake-case'

export const getAllSites = () => getJson(API.GET_SITES)
export const getSite = (uuid) => getJson(API.GET_SITE, {}, { uuid })
export const getPossibleSites = () => getJson(API.GET_POSSIBLE_SITES)
export const editSite = (site) => postJson(API.EDIT_SITE, {}, { ...site })
export const uploadFile = (url, file) => putFile(url, file, file.type)
export const searchSites = (searchTerm, sort, direction, limit, start) => getJson(API.SEARCH_SITES, {}, toSnakeCase({ direction, limit, searchTerm, sort, start }))
export const addSite = (values) => postJson(API.ADD_SITE, {}, { ...values })
export const addPermittedGroup = (values) => postJson(API.ADD_PERMITTED_GROUP, {}, { ...values })
export const deletePermittedGroup = (group) => postJson(API.DELETE_PERMITTED_GROUP, {}, group)
export const deleteSite = (uuid) => postJson(API.DELETE_SITE, {}, { uuid })
export const editPermittedGroup = (values) => postJson(API.EDIT_PERMITTED_GROUP, {}, { ...values })
